import { FETCH_USER_DATA, RESET_FETCHED } from "../actions/userData";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_DATA:
      const { packages, account, lockers, merchant } = action.payload;
      return {
        ...state,
        packages,
        account,
        lockers,
        fetched: true,
        merchant
      };
    case RESET_FETCHED:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
